
export const fetchUserHistoryApi = (BeURL, setLogHistory, currentPage, rowsPerPage, setTotlaSessionLogs, setTotalPage, id) => {
    fetch(`${BeURL}/fetch-Logs-History/${id}`, {
        method: 'POST',
       headers : {
            'Content-Type' : 'application/json'
        },
        credentials : 'include',
        body:  JSON.stringify({ pages: currentPage,  sessionLogsPerPage: rowsPerPage })
    })
        .then(res => res.json())
        .then(data => {
            if (data.success === true) {
                setLogHistory(data?.logHistory);
                // navigate(`/fetch-log-history`);
                  setTotlaSessionLogs(data.totalLogs)
            setTotalPage(data.totalPages)
            }
        })
        .catch(err => {
            console.error('Error fetching session logs:', err);
        });
};
